import { Api } from '../api';
import { auth } from '../endpoints';
import { LoginRequest, LoginResponse, RecoveryRequest, TwoFactorRequest } from './models';

export class AuthApi extends Api {
  static login = (request: LoginRequest, signal?: AbortSignal) =>
    this.plainPost<LoginRequest, LoginResponse>({ url: auth.login(), data: request, signal });

  static twoFactor = (request: TwoFactorRequest, signal?: AbortSignal) =>
    this.plainPost<TwoFactorRequest, LoginResponse>({ url: auth.twoFactor(), data: request, signal });

  static logout = () => this.plainPost({ url: auth.logout() });

  static recovery = (request: RecoveryRequest, signal?: AbortSignal) =>
    this.plainPost<RecoveryRequest, string>({ url: auth.recovery(), data: request, signal });
}
